export default function useLegalMentions(tunnelData) {
  const { legalMentions } = tunnelData

  let legalsToDisplay = []

  // Override of specific variables by one and only that manages all pages
  if (legalMentions && legalMentions.length > 0) {
    const legalsOfCurrentStep = legalMentions?.filter((x) => x?.steps?.includes(tunnelData?.step))
    legalsOfCurrentStep.forEach((x) => {
      const mentions = x.mentions?.map((y) => y)
      legalsToDisplay = legalsToDisplay.concat(mentions)
    })
  }
  /*
  IF ROLLBACK NEEDED, UNCOMMENT THIS
    const { legalMentionBaseBloc, contractDownloadpng, legalMentionSpecificBloc, retailLegalMentionBaseBloc, step } =
    tunnelData
  else {
    legalsToDisplay = prepareLegalMentionsSpecifics(
      step,
      legalMentionBaseBloc,
      retailLegalMentionBaseBloc,
      legalMentionSpecificBloc,
      contractDownloadpng
    )
  }*/

  legalsToDisplay = legalsToDisplay?.sort((e1, e2) => e1.order - e2.order).map((e) => e?.description)

  if (legalsToDisplay.includes("conforama_withdrawal_paragraph_2")) {
    legalsToDisplay = legalsToDisplay.filter(function (element) {
      return element !== "conforama_withdrawal_paragraph"
    })
  }
  return {
    legalsToDisplay
  }
}

/* UNCOMMENT IF ROLLBACK NEEDED
function prepareLegalMentionsSpecifics(
  step,
  legalMentionBaseBloc,
  retailLegalMentionBaseBloc,
  legalMentionSpecificBloc,
  contractDownloadpng
) {
  let legalsToConcat = []
  if (legalMentionBaseBloc.length === 0) {
    legalsToConcat = legalMentionSpecificBloc
  } else if (retailLegalMentionBaseBloc && retailLegalMentionBaseBloc.length > 0) {
    if (step === STEPS.HOME || step === STEPS.SIMULATION) {
      legalsToConcat = retailLegalMentionBaseBloc
    }
  } else if (legalMentionSpecificBloc > 0) {
    if (step === STEPS.IDENTIFICATION) {
      legalsToConcat = legalsToConcat.concat(legalMentionSpecificBloc)
    }
    if (step === STEPS.CB) {
      legalsToConcat = legalsToConcat.concat(legalMentionSpecificBloc)
    }
    if (step === STEPS.CLIENT) {
      legalsToConcat = legalsToConcat.concat(legalMentionSpecificBloc)
    }
    if (step === STEPS.SUMMARY) {
      legalsToConcat = legalsToConcat.concat(legalMentionSpecificBloc)
    }
  }
  legalMentionBaseBloc.concat(contractDownloadpng)
  return legalsToConcat
}
*/
